if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.productId = this.dataset.productId;
      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.buyNowButton = this.querySelector('[data-fast-checkout]');
      this.checkoutInput = this.querySelector('input[name="return_to"][value="/checkout"]');

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', () => {
          this.buyNowButton.setAttribute('aria-disabled', true);
          this.buyNowButton.classList.add('is-loading');
          if (this.checkoutInput) this.checkoutInput.removeAttribute('disabled');
          this.form.submit();
        });
      }
    }

    onSubmitHandler(event) {
      if (!this.cartDrawer) return;

      event.preventDefault();
      if (this.submitButton.classList.contains('is-loading')) return;

      this.handleErrorMessage();
      this.cartDrawer.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('is-loading');

      const fetchedData = this.addItemToCart();
      this.handleFetchedData(fetchedData);
    }

    addItemToCart() {
      return new Promise((resolve, reject) => {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const quantityInput = this.form.querySelector('[name="quantity"]');
        if (quantityInput) {
          formData.set('quantity', quantityInput.value);
        }

        // Ask Shopify to return section HTML (drawer + bubble)
        const sectionsForAdd = this.cartDrawer.getSectionsToRender().map((s) => s.id);
        if (!sectionsForAdd.includes('cart-icon-bubble')) {
          sectionsForAdd.push('cart-icon-bubble');
        }

        formData.append('sections', sectionsForAdd);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response) {
              resolve(response);
              return;
            }
            this.submitButton.classList.remove('is-loading');
            this.submitButton.removeAttribute('aria-disabled');
            reject(response);
          })
          .catch((e) => {
            console.error(e);
            reject(e);
          });
      });
    }

    handleFetchedData(promise) {
      Promise.all([promise])
        .then((values) => {
          if (values.length === 0) return;

          const fetchedData = values[0];

          // Handle Shopify 422 error (stock limit adjusted)
          if (fetchedData && fetchedData.status === 422) {
            this.handleErrorMessage(fetchedData.description || fetchedData.message);

            const sectionsToRender = this.cartDrawer.getSectionsToRender();
            const handles = sectionsToRender.map((s) => s.section);
            const refreshUrl = `${routes.cart_url}?sections=${handles.join(',')}&sections_url=${encodeURIComponent(window.location.pathname)}`;

            Promise.all([
              fetch(refreshUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((r) => r.json()),
              fetch('/cart.js').then((r) => r.json())
            ])
              .then(([sectionsJson, cartJson]) => {
                const parsedState = { item_count: cartJson.item_count, sections: sectionsJson };

                if (this.cartDrawer && typeof this.cartDrawer.renderContents === 'function') {
                  this.cartDrawer.renderContents(parsedState, false, '', '', false);
                }

                const bubble = document.querySelector('#cart-icon-bubble');
                if (bubble && sectionsJson['cart-icon-bubble']) {
                  bubble.innerHTML = sectionsJson['cart-icon-bubble'];
                }

                const countEl = document.querySelector('[data-js-cart-item-count]');
                if (countEl && typeof cartJson.item_count === 'number') {
                  countEl.innerText = cartJson.item_count;
                  countEl.classList.toggle('is-active', cartJson.item_count > 0);
                }
              })
              .catch((err) => console.error('Cart refresh failed', err));

            return; // stop normal flow
          }

          // Normal add-to-cart flow
          if (this.cartDrawer && typeof this.cartDrawer.handleAddedItem === 'function') {
            this.cartDrawer.handleAddedItem(fetchedData);
          }

          const quickview = document.querySelector(`#Product-Quickview-${this.productId}`);
          if (quickview) quickview.hide();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('is-loading');
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.main-product__form-error-message-wrapper');
      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper.querySelector('.main-product__form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    getSectionInnerHTML(sectionHTML, selector) {
      try {
        const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const el = doc.querySelector(selector);
        return el ? el.innerHTML : sectionHTML;
      } catch (e) {
        console.error('getSectionInnerHTML failed', e);
        return sectionHTML;
      }
    }
  });
}
